<template>
  <div class="pt-4">
    <div>
      <div class="row mx-3">
        <!-- MENU -->
        <div class="col-2">
          <NotificationCenterMenu
            :sections="sections"
            @click="updateSelectedSection"
            @filters-update="updateCurrentFilters"
          />
        </div>

        <!-- MAIN (NOTIFICATIONS OR FEEDBACKS)-->
        <div class="col-7 notification-center-section mb-4 pt-2">
          <NotificationCenterMain
            :notifications="createdAgentNotifications(groups)"
            :filters="targetGroups"
            @select-details="selectedNotification = $event"
            v-loading="isLoadingAgentNotifications"
          />
        </div>

        <!-- DETAILS -->
        <div class="col-3 mt-2" v-if="selectedNotification !== null">
          <NotificationCenterDetails
            :data="selectedNotification"
            @close="selectedNotification = null"
          />
        </div>
      </div>
    </div>

    <ModalEvents
      modal-name="CreateNotificationModal"
      :uid="createNotificationUniqueKey"
      @choice="addNotification"
      @close="modals.addNotification = false"
    />

    <!-- Floating button -->
    <MaydayFloatingButton
      @click="openNotificationModal"
      :state="modals.addNotification"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import NotificationCenterMenu from './Menu/NotificationCenterMenu';
import NotificationCenterDetails from './Details/NotificationCenterDetails';
import NotificationCenterMain from './Main/NotificationCenterMain';
import MaydayFloatingButton from 'components/MaydayFloatingButton';
import ModalEvents from '@/components/Modals/ModalEvents';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'NotificationCenter',
  components: {
    NotificationCenterMenu,
    NotificationCenterDetails,
    NotificationCenterMain,
    ModalEvents,
    MaydayFloatingButton,
  },
  data() {
    return {
      modals: {
        addNotification: false,
      },
      selectedNotification: null,
      sections: [
        {
          title: 'Notifications',
          icon: ['fad', 'paper-plane'],
          description: this.$t('notification-center.notif-page-subtitle'),
          data: [],
          selected: true,
        },
      ],
    };
  },
  async created() {
    await this.getCompanyGroups();
    const isFromNotificationCenter = true;
    this.updateFilters({
      field: 'targetGroups',
      value: this.groups,
      isFromNotificationCenter,
    });
  },
  computed: {
    createNotificationUniqueKey() {
      return `${this.$options.name}-modal`;
    },
    ...mapState(['companyId']),
    ...mapGetters('adminModule', ['groups']),
    ...mapGetters('notificationModule', [
      'createdAgentNotifications',
      'isLoadingAgentNotifications',
      'targetGroups',
    ]),
  },
  validations: {
    new_title: {
      required,
    },
    new_message: {
      required,
    },
  },
  methods: {
    async updateCurrentFilters(groups) {
      await this.updateFilters({
        field: 'targetGroups',
        value: groups,
      });
      await this.getCreatedAgentNotifications();
    },
    addNotification({ notification }) {
      if (notification) {
        notification.companyId = this.companyId;
        this.addAgentNotification({ notification });
      }
      this.modals.addNotification = false;
    },
    updateSelectedSection(event) {
      this.sections.forEach((elem) => {
        if (elem.title == event) {
          elem.selected = true;
        } else elem.selected = false;
      });
    },
    openNotificationModal() {
      const payload = {
        component: 'CreateNotificationModal',
        uid: this.createNotificationUniqueKey,
        props: {
          open: true,
        },
      };
      this.openModal(payload);
      this.modals.addNotification = true;
    },
    ...mapActions('adminModule', ['getCompanyGroups']),
    ...mapActions('notificationModule', [
      'getCreatedAgentNotifications',
      'updateFilters',
      'addAgentNotification',
    ]),
    ...mapActions('modalsModule', ['openModal']),
  },
};
</script>
